var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 9.5C1.5 8.94772 1.94772 8.5 2.5 8.5H21.5C22.0523 8.5 22.5 8.94772 22.5 9.5V20C22.5 21.1046 21.6046 22 20.5 22H3.5C2.39544 22 1.5 21.1046 1.5 20V9.5ZM3.5 10.5V20H20.5V10.5H3.5Z",
    fill: "#141415"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 4.5C1.5 3.39543 2.39543 2.5 3.5 2.5H20.5C21.6046 2.5 22.5 3.39544 22.5 4.5V9.5C22.5 10.0523 22.0523 10.5 21.5 10.5H2.5C1.94772 10.5 1.5 10.0523 1.5 9.5V4.5ZM20.5 4.5H3.5V8.5H20.5V4.5Z",
    fill: "#141415"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1C8.55228 1 9 1.44772 9 2V6C9 6.55228 8.55228 7 8 7C7.44772 7 7 6.55228 7 6V2C7 1.44772 7.44772 1 8 1Z",
    fill: "#141415"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 1C16.5523 1 17 1.44772 17 2V6C17 6.55228 16.5523 7 16 7C15.4477 7 15 6.55228 15 6V2C15 1.44772 15.4477 1 16 1Z",
    fill: "#141415"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 17C13 16.4477 13.4477 16 14 16H17C17.5523 16 18 16.4477 18 17C18 17.5523 17.5523 18 17 18H14C13.4477 18 13 17.5523 13 17Z",
    fill: "#141415"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 17C6 16.4477 6.44772 16 7 16H10C10.5523 16 11 16.4477 11 17C11 17.5523 10.5523 18 10 18H7C6.44772 18 6 17.5523 6 17Z",
    fill: "#141415"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 13C13 12.4477 13.4477 12 14 12H17C17.5523 12 18 12.4477 18 13C18 13.5523 17.5523 14 17 14H14C13.4477 14 13 13.5523 13 13Z",
    fill: "#141415"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 13C6 12.4477 6.44772 12 7 12H10C10.5523 12 11 12.4477 11 13C11 13.5523 10.5523 14 10 14H7C6.44772 14 6 13.5523 6 13Z",
    fill: "#141415"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.d35309a99c0b69172b4d399c3e1bcd7d.svg";
export { ForwardRef as ReactComponent };